module.exports = __webpack_public_path__ + "static/media/signature.fae2d609.svg";